














import { defineComponent, reactive, ref } from '@vue/composition-api';
import { signin } from '../oidc';
import { useRouter } from '../router';

export default defineComponent({
    name: 'Access',

    setup(props, context) {
        const { router, route } = useRouter();

        const signinLoading = ref(false);

        const onSignin = async () => {
            try {
                signinLoading.value = true;
                const user = await signin();
                if (user) {
                    router.replace({name: 'apps'});
                }
            }
            finally {
                signinLoading.value = false;
            }
        }

        return {
            onSignin,
            signinLoading
        }
    },
})

